var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgNina = function SvgNina(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-4.405-9.87a1.465 1.465 0 1 0-2.93 0v2.042H4v-4.083h.666v.655C4.984 10.29 5.483 10 6.13 10a2.13 2.13 0 0 1 2.13 2.13v2.042h-.665V12.13Zm1.576-2.041h.665v4.083h-.665v-4.083Zm3.75.577c.809 0 1.465.655 1.465 1.464v2.042h.665V12.13a2.13 2.13 0 0 0-2.13-2.13c-.647 0-1.146.289-1.465.744v-.655h-.665v4.083h.665V12.13c0-.809.656-1.464 1.465-1.464ZM17.87 10a2.13 2.13 0 1 0 0 4.26c.647 0 1.146-.288 1.464-.743v.655H20v-4.083h-.666v.655c-.318-.455-.817-.744-1.464-.744Zm1.464 2.13a1.465 1.465 0 1 0-2.93 0 1.465 1.465 0 0 0 2.93 0Z",
    fill: "currentColor"
  })));
};
export default SvgNina;